import { usePostHog } from "@posthog/react";

import { getMarketingUrl } from "../../lib/marketing-url";
import {
  captureHowItWorksClicked,
  type HowItWorksSurface,
} from "../../lib/marketplace-analytics";
import { cn } from "../../lib/utils";

/**
 * The one consumer affordance onto the public "How the marketplace works"
 * article (M11-B3, plan 326). Mounted on exactly TWO surfaces — the publish
 * confirm dialog and the browse not-launched state — the two moments a buyer
 * is deciding whether to expose themselves. Do not add it to the sidebar, the
 * passport card, or the offer pages; two entry points is the whole spec.
 *
 * Cross-app link via `getMarketingUrl` (never a hardcoded host); opens in a
 * new tab so the dialog / browse state underneath is not lost. Telemetry is
 * one allowlisted event keyed by `surface`; a missing PostHog client (DEV
 * fixtures, `/preview/*`) degrades to a plain link.
 */
export function MarketplaceHowItWorksLink({
  surface,
  className,
}: {
  surface: HowItWorksSurface;
  className?: string;
}) {
  const posthog = usePostHog();
  return (
    <a
      className={cn(
        "inline-flex text-sm font-medium text-primary underline-offset-4 hover:underline",
        className,
      )}
      data-testid="marketplace-how-it-works-link"
      href={getMarketingUrl("/help/buyers/marketplace")}
      onClick={() => {
        if (posthog?.capture) {
          captureHowItWorksClicked(posthog.capture.bind(posthog), surface);
        }
      }}
      rel="noreferrer"
      target="_blank"
    >
      How the marketplace works →
    </a>
  );
}
